import { Navigate, Route } from "react-router";
import DefaultsettingsForm from "./views/Defaultsettings/DefaultsettingsForm";
import Profiel from "./views/Profiel/Index";
import Passwordchange from "./views/Profiel/Passwordchange";
import ImportExport from "./views/ImportExport/Index";
import DashboardPage from "./views/Dashboard/Dashboard";
import RapportagePage from "./views/Rapporten/Layout";
import AlgemeenMain from "./views/Rapporten/Algemeen/Main";
import SalesProducten from "./views/Rapporten/Sales/Producten";
import SalesTafels from "./views/Rapporten/Sales/Tafels";
import SalesExport from "./views/Rapporten/Sales/Export";
import OverigeBerichten from "./views/Rapporten/Overige/Berichten";
import VenueForm from "./views/Venues/VenueForm";
import SubsPricePlansIndex from "./views/SubsPricePlans/SubsPricePlansIndex";
import SubsPricePlanForm from "./views/SubsPricePlans/SubsPricePlanForm";
import SubsDebtorsIndex from "./views/SubsDebtors/SubsDebtorsIndex";
import SubsInvoicesIndex from "./views/SubsInvoices/SubsInvoicesIndex";
import SubsInvoiceForm from "./views/SubsInvoices/SubsInvoiceForm";
import SubsDebtorForm from "./views/SubsDebtors/SubsDebtorForm";
import SubsResellersIndex from "./views/SubsResellers/SubsResellersIndex";
import SubsResellerForm from "./views/SubsResellers/SubsResellerForm";
import SubsDashboard from "./views/SubsDashboard/SubsDashboard";
import Profiles from "./views/Permissions/Profiles";
import ProfileForm from "./views/Permissions/ProfileForm";
import Roles from "./views/Permissions/Roles";
import RoleForm from "./views/Permissions/RoleForm";
import PermissionForm from "./views/Permissions/PermissionForm";
import Permissions from "./views/Permissions/Permissions";
import ArticleTraitValues from "./views/ArticlegroupTrait/ArticlegroupTraitValue/ArticleTraitValues";
import ArticleTraitValueForm from "./views/ArticlegroupTrait/ArticleTraitValueForm";
import ArticleTraits from "./views/ArticlegroupTrait/ArticlegroupTrait/ArticleTraits";
import ArticleTraitForm from "./views/ArticlegroupTrait/ArticleTraitForm";
import OptionGroups from "./views/OptionGroups/OptionGroups";
import OptionGroupForm from "./views/OptionGroups/OptionGroupForm";
import ScheduledTasks from "./views/ScheduledTasks/ScheduledTasks";
import ScheduledTaskForm from "./views/ScheduledTasks/ScheduledTaskForm";
import TafelForm from "./views/Tafels/TafelForm";
import SubsSubscriptionFormV2 from "./views/SubsSubscriptions/SubsSubscriptionFormV2";
import CampaignsIndex from "./views/Campaigns/CampaignsIndex";
import CampaignForm from "./views/Campaigns/CampaignForm";
import ArrangementGroups from "./views/Arrangements/ArrangementGroups/ArrangementGroups";
import ArrangementGroupForm from "./views/Arrangements/ArrangementGroups/ArrangementGroupForm";
import ArrangementForm from "./views/Arrangements/Arrangements/ArrangementForm";
import Arrangements from "./views/Arrangements/Arrangements/Arrangements";
import PackagingTypes from "./views/Packaging/PackagingTypes/PackagingTypes";
import PackagingTypeForm from "./views/Packaging/PackagingTypes/PackagingTypeForm";
import Packagings from "./views/Packaging/Packagings/Packagings";
import PackagingForm from "./views/Packaging/Packagings/PackagingForm";
import Timeschedules from "./views/Timeschedules/Timeschedules";
import TimescheduleForm from "./views/Timeschedules/TimescheduleForm";
import UpsellPage from "./views/Upsell/upsellPage";
import PriceLinesPage from "../../Domains/PriceLines/pages/PriceLinesPage";

/*VENUES*/
import Venues from "./views/Venues/Index";
import SubsSubscriptionsIndex from "./views/SubsSubscriptions/SubsSubscriptionsIndex";

/*VESTIGINGEN*/
import Vestigingen from "./views/Vestigingen/Index";
import VestigingenForm from "./views/Vestigingen/VestigingForm";

/*MENUKAARTEN*/
import Menukaarten from "./views/Menukaarten/Index";
import MenukaartForm from "./views/Menukaarten/MenukaartForm";

/*PRODUCTEN*/
import Producten from "./views/Producten/Index";
import ProductForm from "./views/Producten/ProductForm";
import ProductenImport from "./views/Producten/Import";

/*TAFELS*/
import Tafels from "./views/Tafels/Index";

import TafelsBulk from "./views/Tafels/Bulk";

/*ZONES*/
import Zones from "./views/Zones/Index";
import ZoneForm from "./views/Zones/ZoneForm";

/* REVIEWS */
import Reviews from "./views/Reviews/Index";

/*TAGS*/
import Tags from "./views/Tags/Index";
import TagForm from "./views/Tags/TagForm";

/*PREORDERING*/
import Preordering from "./views/Preordering/Index";
import PreorderingForm from "./views/Preordering/PreorderingForm";
import PreorderingImport from "./views/Preordering/Import";

/*BESTELLINGEN*/
import Bestellingen from "./views/Bestellingen/Index";
import BestllingenDetail from "./views/Bestellingen/Detail";

/*POSTCODE_BLACKLISTS*/
/*VOUCHERS*/
import Transedit from "./views/Transedit/Index";
import BackofficeTranslations from "./views/BackofficeTranslations/Index";

/*PRINTERS*/
import Printers from "./views/Printers/Index";

import PrinterForm from "./views/Printers/PrinterForm";
import PrintersQueue from "./views/Printerqueue/Index";

/*APILOG*/
import Apilog from "./views/Apilog/Index";

/*SERVICELOG */
import ServiceLog from "./views/ServiceLog/Index";

/*VOUCHERS*/
import Vouchers from "./views/Vouchers/Index";
import VoucherForm from "./views/Vouchers/VoucherForm";

/*VOUCHERDEFS*/
import VoucherDefs from "./views/VoucherDefs/Index";
import VoucherDefsForm from "./views/VoucherDefs/VoucherDefsForm";

/**
 * Callback LOG
 */
import Callbacklog from "./views/Callbacklog/Index";

/**
 * Shortlinks
 */
import Shortlinks from "./views/Shortlinks/Index";
import ShortlinkForm from "./views/Shortlinks/ShortlinkForm";

/**
 * Notifications
 */
import Notificaties from "./views/Notifications/Index";
import NotificationForm from "./views/Notifications/NotificationForm";

/*GEBRUIKERS*/
import Gebruikers from "./views/Gebruikers/Index";
import GebruikersForm from "./views/Gebruikers/Form";

/* Relaties */
import Relations from "./views/Relations/Index";
import RelationForm from "./views/Relations/RelationForm";

/* Support */
/* Statistics */
/**
 * Gateways
 */
import Gateways from "./views/Gateways/Index";
import GatewaysForm from "./views/Gateways/GatewaysForm";

/**
 * Resellers
 */
import ResellersExport from "./views/ResellersExport/Index";

/**
 * Invoice Customers
 */
/**
 * Subscriptions
 */
/**
 * Smslog
 */
import Smslog from "./views/Smslog/Index";

/**
 * Checkpayment
 */
import Checkpayment from "./views/Bestellingen/Checkpayment";

/**
 * Default settings
 */
import Defaultsettings from "./views/Defaultsettings/Index";
import React from "react";
import Login from "./views/Auth/Login";
import Setup2FA from "./views/Auth/Setup2FA";
import AdminLayout from "./layouts/Admin";
import BiPage from "./views/Bi/Index";
import PaymentsPage from "../../Domains/Payments/PaymentsPage/PaymentsPage";
import PaymentDetailPage from "../../Domains/Payments/PaymentDetailPage";

export const AppRoutes = (
  <Route>
    <Route path={"/manager"}>
      <Route element={<Login />} path={"login"} />
      <Route element={<Setup2FA />} path={"2fa"} />
      <Route element={<Setup2FA />} path={"2fa/renew"} />
    </Route>

    <Route element={<AdminLayout />} path={"/manager"}>
      {/* Redirect for root path */}
      <Route element={<Navigate replace to={"/manager/dashboard"} />} index />

      {/* Login, and 2fa routes */}

      <Route element={<Profiel />} path={"profiel"} />
      <Route element={<Passwordchange />} path={"profiel/password-change"} />

      <Route element={<DashboardPage />} path={"dashboard"} />

      <Route element={<RapportagePage />} path={"rapportages"}>
        <Route element={<Navigate replace to={"/manager/rapportages/algemeen"} />} index />
        <Route element={<AlgemeenMain />} path={"algemeen"} />
        <Route path={"sales"}>
          <Route element={<Navigate replace to={"producten"} />} index />
          <Route element={<SalesProducten />} path={"producten"} />
          <Route element={<SalesTafels />} path={"tafels"} />
          <Route element={<SalesExport />} path={"export"} />
        </Route>
        <Route path={"overige"}>
          <Route element={<OverigeBerichten />} index />
        </Route>
      </Route>
      <Route element={<BiPage />} path={"bi"} />

      <Route path={"venues"}>
        <Route element={<Venues />} index />
        <Route element={<VenueForm />} path={":id/edit"} />
      </Route>

      <Route path={"vestigingen"}>
        <Route element={<Vestigingen />} index />
        <Route element={<VestigingenForm />} path={"create"} />
        <Route element={<VestigingenForm />} path={":id/edit"} />
      </Route>

      <Route path={"kaarten"}>
        <Route element={<Menukaarten />} index />
        <Route element={<MenukaartForm />} path={"create"} />
        <Route element={<MenukaartForm />} path={":id/edit"} />
      </Route>

      <Route path={"producten"}>
        <Route element={<Producten />} index />
        <Route element={<ProductForm />} path={"create"} />
        <Route element={<ProductForm />} path={":id/edit"} />
        <Route element={<ProductenImport />} path={"import"} />
      </Route>

      <Route path={"optionGroups"}>
        <Route element={<OptionGroups />} index />
        <Route element={<OptionGroupForm />} path={"create"} />
        <Route element={<OptionGroupForm />} path={":id/edit"} />
      </Route>

      <Route path={"upsell"}>
        <Route element={<UpsellPage />} index />
        <Route element={<>hoi</>} path={":upsellId/flow/:flowId"} />
      </Route>

      <Route path={"tags"}>
        <Route element={<Tags />} index />
        <Route element={<TagForm />} path={"create"} />
        <Route element={<TagForm />} path={":id/edit"} />
      </Route>

      <Route path={"campaigns"}>
        <Route element={<CampaignsIndex />} index />
        <Route element={<CampaignForm />} path={"create"} />
        <Route element={<CampaignForm />} path={":id/edit"} />
      </Route>

      <Route element={<PriceLinesPage />} path={"price-lines"} />

      <Route path={"timeschedules"}>
        <Route element={<Timeschedules />} index />
        <Route element={<TimescheduleForm />} path={"create"} />
        <Route element={<TimescheduleForm />} path={":id/edit"} />
      </Route>

      <Route path={"arrangement-groups"}>
        <Route element={<ArrangementGroups />} index />
        <Route element={<ArrangementGroupForm />} path={"create"} />
        <Route element={<ArrangementGroupForm />} path={":id/edit"} />
      </Route>

      <Route path={"arrangements"}>
        <Route element={<Arrangements />} index />
        <Route element={<ArrangementForm />} path={"create"} />
        <Route element={<ArrangementForm />} path={":id/edit"} />
      </Route>

      <Route path={"packaging-types"}>
        <Route element={<PackagingTypes />} index />
        <Route element={<PackagingTypeForm />} path={"create"} />
        <Route element={<PackagingTypeForm />} path={":id/edit"} />
      </Route>

      <Route path={"packagings"}>
        <Route element={<Packagings />} index />
        <Route element={<PackagingForm />} path={"create"} />
        <Route element={<PackagingForm />} path={":id/edit"} />
      </Route>

      <Route path={"tafels"}>
        <Route element={<Tafels />} index />
        <Route element={<TafelForm />} path={"create"} />
        <Route element={<TafelForm />} path={":id/edit"} />
        <Route element={<TafelsBulk />} path={"bulk"} />
      </Route>

      <Route path={"zones"}>
        <Route element={<Zones />} index />
        <Route element={<ZoneForm />} path={"create"} />
        <Route element={<ZoneForm />} path={":id/edit"} />
      </Route>

      <Route path={"reviews"}>
        <Route element={<Reviews />} index />
      </Route>

      <Route path={"preordering"}>
        <Route element={<Preordering />} index />
        <Route element={<PreorderingForm />} path={"create"} />
        <Route element={<PreorderingForm />} path={":id/edit"} />
        <Route element={<PreorderingImport />} path={"import"} />
      </Route>

      <Route path={"bestellingen"}>
        <Route element={<Bestellingen />} index />
        <Route element={<BestllingenDetail />} path={":id"} />
      </Route>
      <Route path={"payments"}>
        <Route element={<PaymentsPage />} index />
        <Route element={<PaymentDetailPage />} path={":id"} />
      </Route>

      <Route path={"voucherDefs"}>
        <Route element={<VoucherDefs />} index />
        <Route element={<VoucherDefsForm />} path={"create"} />
        <Route element={<VoucherDefsForm />} path={":id/edit"} />
      </Route>

      <Route path={"vouchers"}>
        <Route element={<Vouchers />} index />
        <Route element={<VoucherForm />} path={"create"} />
        <Route element={<VoucherForm />} path={":id/edit"} />
      </Route>

      <Route path={"transedit"}>
        <Route element={<Transedit />} index />
      </Route>

      <Route path={"backoffice-translations"}>
        <Route element={<BackofficeTranslations />} index />
      </Route>

      <Route path={"printers"}>
        <Route element={<Printers />} index />
        <Route element={<PrinterForm />} path={"create"} />
        <Route element={<PrinterForm />} path={":id/edit"} />
      </Route>

      <Route element={<PrintersQueue />} path={"printerqueue"} />

      <Route path={"shortlinks"}>
        <Route element={<Shortlinks />} index />
        <Route element={<ShortlinkForm />} path={"create"} />
        <Route element={<ShortlinkForm />} path={":id/edit"} />
      </Route>

      <Route path={"notifications"}>
        <Route element={<Notificaties />} index />
        <Route element={<NotificationForm />} path={"create"} />
        <Route element={<NotificationForm />} path={":id/edit"} />
      </Route>

      <Route path={"gebruikers"}>
        <Route element={<Gebruikers />} index />
        <Route element={<GebruikersForm />} path={"create"} />
        <Route element={<GebruikersForm />} path={":id/edit"} />
      </Route>

      <Route path={"profiles"}>
        <Route element={<Profiles />} index />
        <Route element={<ProfileForm />} path={":id/edit"} />
      </Route>

      <Route path={"roles"}>
        <Route element={<Roles />} index />
        <Route element={<RoleForm />} path={":id/edit"} />
      </Route>

      <Route path={"permissions"}>
        <Route element={<Permissions />} index />
        <Route element={<PermissionForm />} path={":id/edit"} />
      </Route>

      <Route path={"relations"}>
        <Route element={<Relations />} index />
        <Route element={<RelationForm />} path={"create"} />
        <Route element={<RelationForm />} path={":id/edit"} />
      </Route>

      <Route element={<Apilog />} path={"apilog"} />
      <Route element={<ServiceLog />} path={"servicelog"} />
      <Route element={<Smslog />} path={"smslog"} />
      <Route element={<Callbacklog />} path={"callbacklog"} />

      <Route path={"gateways"}>
        <Route element={<Gateways />} index />
        <Route element={<GatewaysForm />} path={"create"} />
        <Route element={<GatewaysForm />} path={":id/edit"} />
      </Route>

      <Route path={"scheduledTasks"}>
        <Route element={<ScheduledTasks />} index />
        <Route element={<ScheduledTaskForm />} path={"create"} />
        <Route element={<ScheduledTaskForm />} path={":id/edit"} />
      </Route>

      <Route element={<SubsDashboard />} path={"subsdashboard"} />

      <Route path={"subssubscriptions"}>
        <Route element={<SubsSubscriptionsIndex />} index />
        <Route element={<SubsSubscriptionFormV2 />} path={"create"} />
        <Route element={<SubsSubscriptionFormV2 />} path={":id/edit"} />
      </Route>

      <Route path={"subsdebtors"}>
        <Route element={<SubsDebtorsIndex />} index />
        <Route element={<SubsDebtorForm />} path={":id/edit"} />
      </Route>

      <Route path={"subsinvoices"}>
        <Route element={<SubsInvoicesIndex />} index />
        <Route element={<SubsInvoiceForm />} path={":id/edit"} />
      </Route>

      <Route path={"subspriceplans"}>
        <Route element={<SubsPricePlansIndex />} index />
        <Route element={<SubsPricePlanForm />} path={":id/edit"} />
      </Route>

      <Route path={"subsresellers"}>
        <Route element={<SubsResellersIndex />} index />
        <Route element={<SubsResellerForm />} path={":id/edit"} />
      </Route>

      <Route element={<ResellersExport />} path={"resexp"} />
      <Route element={<Checkpayment />} path={"checkpayment"} />
      <Route element={<ImportExport />} path={"importexport"} />

      <Route path={"defaultsettings"}>
        <Route element={<Defaultsettings />} index />
        <Route element={<DefaultsettingsForm />} path={"create"} />
        <Route element={<DefaultsettingsForm />} path={":id/edit"} />
      </Route>
      <Route path={"articleTraitValues"}>
        <Route element={<ArticleTraitValues />} index />
        <Route element={<ArticleTraitValueForm />} path={":id/edit"} />
      </Route>

      <Route element={<ArticleTraits />} path={"articleTraits"} />
      <Route element={<ArticleTraitForm />} path={"articleTraits/:id/edit"} />
    </Route>
  </Route>
);
